import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export function tenDigitsValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const numerals = (control.value || "").split(',');
        return numerals.length == 10 ? null : { tenDigits: true };
    };
}
